import { encounterCreatureField, encounterField, layerValue } from '../../shared/array-types.js';
import { _ftCamField } from '../../shared/campaign-field.js';
type Row = Record<string, unknown>;
const row = (v: unknown): Row | null => v && typeof v === 'object' && !Array.isArray(v) ? v as Row : null;
const upper = (v: unknown): string => String(v ?? '').trim().toUpperCase();

/** ft_campaign_context: the embedded campaign, then the PC's attached campaign, then a campaign master parent. */
export function timedEquipCampaignId(actor: Row, encounter: Row | null): string {
  return upper(_ftCamField(row(actor.campaign_arr), 'campaign_id'))
    || upper(layerValue(row(actor.player_characters)?.attached_campaign_id))
    || (encounterField(encounter, 'encounter_master_parent_type') === 'campaign' ? upper(encounterField(encounter, 'encounter_master_parent_id')) : '');
}

/** Pure decision over held saved rows. Load missing context before calling; an encounter with no campaign skips the timer. */
export function timedEquipTimerSkipped(actor: Row, encounter: Row | null, campaign: Row | null): boolean {
  if (!timedEquipCampaignId(actor, encounter)) return true;
  const here = upper(encounterCreatureField(row(actor.encounter_creatures), 'encounter_id'));
  return !!here && ['campaign_campsite_encounter_id', 'campaign_stronghold_encounter_id'].some(key =>
    upper(_ftCamField(campaign, key) ?? layerValue(row(campaign?.item_layer_types)?.[key])) === here);
}
